import React, { useRef, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const [success, setSuccess] = useState(false);
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_0q9lxfp",
        "template_2zsvk6d",
        form.current,
        "_ASHUVaooGOp-XAsX"
      )
      .then(
        () => {
          console.log("SUCCESS!");
          setSuccess(true);
          form.current.reset();
          // window.location = window.location + "#contact"; // Display success message
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
  };
  return (
    <div className=" flex flex-col  justify-center items-center px-4">
      <div className="lg:w-[1300px] lg:h-[539px] rounded-[52px] lg:bg-[#F7F9FA] lg:py-20 lg:px-32 flex lg:flex-row flex-col lg:gap-40 gap-14">
        <div className="flex flex-col lg:gap-[52px] gap-6 lg:items-start items-center">
          <div className="lg:w-[166px] w-[112px] lg:h-[131px] h-20 flex justify-center items-center">
            <img src="Images/assets/Chat Bubble.svg" alt="" />
          </div>
          <div className="flex flex-col gap-6 items-center">
            <h4 className="text-[#364763] font-semibold lg:text-4xl text-[28px]">
              Have a question?
            </h4>
            <h6 className="text-[#9291A1] font-medium lg:text-2xl text-base">
              Write to us
            </h6>
          </div>
        </div>

        <form
          className="flex lg:w-[591px] w-[354px] flex-col gap-6"
          ref={form}
          onSubmit={sendEmail}
        >
          <div className="flex lg:flex-row flex-col  w-full gap-6">
            <input
              name="name"
              type="text"
              placeholder="Name"
              required
              className="lg:w-[283px] w-full h-[60px]  rounded-xl border border-[#DDE3ED] py-6 px-[30px] text-[#131D2D] focus:border-[#131D2D] outline-none"
            />
            <input
              name="email"
              type="text"
              required
              placeholder="Email"
              className="lg:w-[283px] w-full h-[60px] rounded-xl border border-[#DDE3ED] py-6 px-[30px] text-[#131D2D] focus:border-[#131D2D] outline-none"
            />
          </div>
          <textarea
            name="message"
            placeholder="Message"
            required
            className=" border-[1px]  border-[#DDE3ED] rounded-xl w-full h-[211px] py-4 px-6 text-[#131D2D] text-[16px] resize-none focus:border-[#131D2D] outline-none"
          />
          <button
            type="submit"
            className="lg:w-[227px] w-full h-[60px] rounded-xl px-4 py-[18px] bg-[#131D2D] text-[#F7F9FA] font-semibold text-[19px] flex gap-[10px] justify-center items-center"
          >
            Send Enquiry
            <FaArrowRight />
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
